// extracted by mini-css-extract-plugin
export default {"siteLogo":"siteLogo_siteLogo__9TNXl"};